import request from "@/utils/request";

// 查询订单
export const getChargebill = params => {
	return request({
		url: "/chargebill",
		method: "GET",
		params,
	});
};
// 查询订单数据
export const getChargeBillStats = params => {
	return request({
		url: "/chargebill/stats?1=1",
		method: "GET",
		params,
	});
};
// 导出订单
export const ExportChargebill = params => {
	return request({
		url: "/chargebill/file",
		method: "GET",
		params,
	});
};
// 处理订单
export const setChargebill = data => {
	return request({
		url: "/chargebill",
		method: "POST",
		data,
	});
};
// 导出充电曲线
export const exportChargeCurve = params => {
	return request({
		url: "/chargedata/file",
		method: "GET",
		params,
	});
};
